type Item = {
	date: string; // формат: 'YYYY-MM-DD'
	[key: string]: any; // другие параметры
};

export default function groupByMonthDescending(items: Item[]): Map<string, Item[]> {
	// Сортировка по убыванию даты
	const sorted = [...items].sort((a, b) => {
		return new Date(a.date).getTime() - new Date(b.date).getTime();
	});

	const grouped = new Map<string, Item[]>();

	for (const item of sorted) {
		const monthKey = item.date.slice(0, 7); // 'YYYY-MM'
		if (!grouped.has(monthKey)) {
			grouped.set(monthKey, []);
		}
		grouped.get(monthKey)!.push(item);
	}

	return grouped;
}